module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("AxFM0"))).then(() => parcelRequire('4EduH'));